// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"ou-z","slideIn":"pu-z"};